import type { DialogOptions } from '@morpho-org/ui-v6/client'
import type { ReactNode } from 'react'

import { getLocalStorage } from '@repo/utils/client'

import { getBooleanSessionStorage } from './storage'

export interface Dialog {
  component: ReactNode
  keyStore?: string
  condition: boolean
  store: 'local' | 'session'
  start?: number
  end?: number
  dialogOptions?: DialogOptions
}

/**
 * Get the next active dialog to display based on the current dialog and the list of dialogs
 * @param dialogs - The list of dialogs
 * @returns The next dialog to display and its index
 */
export const getActiveDialog = (dialogs: Dialog[]) => {
  for (let i = 0; i < dialogs.length; i++) {
    const dialog = dialogs[i]
    if (dialog?.start && dialog?.end) {
      const currentDate = new Date()
      const startDate = new Date(dialog?.start)
      const endDate = new Date(dialog?.end)
      if (currentDate < startDate || currentDate > endDate) {
        continue
      }
    }

    let booleanStorage = false
    switch (dialog?.store) {
      case 'local':
        booleanStorage = getLocalStorage(dialog?.keyStore ?? '') === true
        break
      case 'session':
        booleanStorage = getBooleanSessionStorage(dialog?.keyStore ?? '')
        break
    }

    if (dialog?.condition && !booleanStorage) {
      return { dialog }
    }
  }

  return { dialog: null }
}
